module.exports = __webpack_public_path__ + "static/segment-image@2x-950a9f444e2a12eb6e24b89f2d7ec9a1.png";